import React from 'react'
import { connect } from 'react-redux';
import { numberAddCommas } from 'servos/formValidations'
import Option from './Option'

class Other extends React.Component {
  render() {
    const { title, commitment, repaymentTitle} = this.props

    return (
      <div>
        <div className='big'>
          {title}
        </div>
        <Option label='Outstanding balance: '>
          {'$'+numberAddCommas(commitment.balance)}
        </Option>
        <Option label='Monthly repayment: '>
          {'$'+numberAddCommas(commitment.repayment)}
        </Option>
        <Option label='Loan type: '>
          {commitment.loanType}
        </Option>
        { commitment.owner &&
          <Option label='Owner: '>
            {commitment.owner}
          </Option>
        }
        <hr/>
      </div>
    )
  }
}

export default Other
